import { useEffect, useRef } from "react";
import { toast } from "sonner";

type SupabaseNetworkErrorEvent = CustomEvent<{
  message: string;
  endpoint: string;
}>;

const EVENT_NAME = "supabase:network-error";
const TOAST_THROTTLE_MS = 15000;

export function useSupabaseNetworkStatus() {
  const lastToastRef = useRef<number>(0);

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as SupabaseNetworkErrorEvent;
      const now = Date.now();

      if (now - lastToastRef.current < TOAST_THROTTLE_MS) {
        return;
      }

      lastToastRef.current = now;
      const endpoint = customEvent.detail?.endpoint ?? "Supabase";

      toast.error("Problema de conexão com o Supabase", {
        description: `${customEvent.detail?.message || "Não foi possível conectar ao Supabase."}\nEndpoint: ${endpoint}`,
        duration: 6000,
      });
    };

    window.addEventListener(EVENT_NAME, handler as EventListener);
    return () => window.removeEventListener(EVENT_NAME, handler as EventListener);
  }, []);
}
